export const productsData = {
  // 化妝水(保濕型)/300mL
  4550583434991: {
    name: '化妝水(保濕型)',
    number: '4550583434991',
    price: '250',
    img: {
      white_bg: '4550583434991_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '濃稠的質地能充分提供滋潤，保護乾燥的肌膚。推薦乾性膚質的使用者，以及擔心肌膚乾燥的時期使用。',
    cartUrl: 'javascript:;',
  },
  // 化妝水(保濕型)/50mL
  4550583483241: {
    name: '化妝水(保濕型)',
    number: '4550583483241',
    price: '99',
    img: {
      white_bg: '4550583483241_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '濃稠的質地能充分提供滋潤，保護乾燥的肌膚。推薦乾性膚質的使用者，以及擔心肌膚乾燥的時期使用。',
    cartUrl: 'javascript:;',
  },
  // 化妝水(滋潤型)/300mL
  4550583434960: {
    name: '化妝水(滋潤型)',
    number: '4550583434960',
    price: '250',
    img: {
      white_bg: '4550583434960_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '不粘膩的質地，能給予肌膚保濕的潤澤感。推薦中性膚質、混合性膚質的使用者。',
    cartUrl: 'javascript:;',
  },
  // 化妝水(滋潤型)/50mL
  4550583483234: {
    name: '化妝水(滋潤型)',
    number: '4550583483234',
    price: '99',
    img: {
      white_bg: '4550583483234_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '不粘膩的質地，能給予肌膚保濕的潤澤感。推薦中性膚質、混合性膚質的使用者。',
    cartUrl: 'javascript:;',
  },
  // 化妝水(清爽型)/300mL
  4550583434939: {
    name: '化妝水(清爽型)',
    number: '4550583434939',
    price: '250',
    img: {
      white_bg: '4550583434939_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '水潤的使用感，給予肌膚清爽潤澤。推薦油性膚質的使用者，以及容易流汗的時期使用。',
    cartUrl: 'javascript:;',
  },
  // 化妝水(清爽型)/50mL
  4550583483227: {
    name: '化妝水(清爽型)',
    number: '4550583483227',
    price: '99',
    img: {
      white_bg: '4550583483227_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '水潤的使用感，給予肌膚清爽潤澤。推薦油性膚質的使用者，以及容易流汗的時期使用。',
    cartUrl: 'javascript:;',
  },
  // 乳液(保濕型)/200mL
  4550583435059: {
    name: '乳液(保濕型)',
    number: '4550583435059',
    price: '250',
    img: {
      white_bg: '4550583435059_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '充分提供滋潤，保護乾燥的肌膚。推薦乾性膚質的使用者，以及擔心肌膚乾燥的時期使用。',
    cartUrl: 'javascript:;',
  },
  // 乳液(保濕型)/50mL
  4550583483272: {
    name: '乳液(保濕型)',
    number: '4550583483272',
    price: '99',
    img: {
      white_bg: '4550583483272_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '充分提供滋潤，保護乾燥的肌膚。推薦乾性膚質的使用者，以及擔心肌膚乾燥的時期使用。',
    cartUrl: 'javascript:;',
  },
  // 乳液(滋潤型)/200mL
  4550583435035: {
    name: '乳液(滋潤型)',
    number: '4550583435035',
    price: '250',
    img: {
      white_bg: '4550583435035_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '肌膚滲透性佳且質地不粘膩，能給予肌膚保濕的潤澤感。',
    cartUrl: 'javascript:;',
  },
  // 乳液(滋潤型)/50mL
  4550583483265: {
    name: '乳液(滋潤型)',
    number: '4550583483265',
    price: '99',
    img: {
      white_bg: '4550583483265_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '肌膚滲透性佳且質地不粘膩，能給予肌膚保濕的潤澤感。',
    cartUrl: 'javascript:;',
  },
  // 乳液(清爽型)/200mL
  4550583435011: {
    name: '乳液(清爽型)',
    number: '4550583435011',
    price: '250',
    img: {
      white_bg: '4550583435011_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '輕盈的使用感，能給予肌膚水潤清爽的潤澤。推薦油性膚質的使用者，以及容易流汗的時期使用。',
    cartUrl: 'javascript:;',
  },
  // 乳液(清爽型)/50mL
  4550583483258: {
    name: '乳液(清爽型)',
    number: '4550583483258',
    price: '99',
    img: {
      white_bg: '4550583483258_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '輕盈的使用感，能給予肌膚水潤清爽的潤澤。推薦油性膚質的使用者，以及容易流汗的時期使用。',
    cartUrl: 'javascript:;',
  },
  // 保濕乳霜/50g
  4550583435110: {
    name: '保濕乳霜',
    number: '4550583435110',
    price: '290',
    img: {
      white_bg: '4550583435110_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '鎖住肌膚潤澤，調理出健康的肌膚狀態。請待使用完化妝水、乳液、美容液等之後，在肌膚保養的最後一步使用。',
    cartUrl: 'javascript:;',
  },
  // 敏感肌ALL IN ONE美容凝膠/150g
  4550583435080: {
    name: '敏感肌ALL IN ONE美容凝膠',
    number: '4550583435080',
    price: '290',
    img: {
      white_bg: '4550583435080_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '',
    cartUrl: 'javascript:;',
  },
  // 敏感肌ALL IN ONE美容凝膠.攜帶型/30g
  4550583435073: {
    name: '敏感肌ALL IN ONE美容凝膠.攜帶型',
    number: '4550583435073',
    price: '110',
    img: {
      white_bg: '4550583435073_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '',
    cartUrl: 'javascript:;',
  },
  // MUJI角質調理化妝水/300mL
  4550583451325: {
    name: 'MUJI角質調理化妝水',
    number: '4550583451325',
    price: '390',
    img: {
      white_bg: '4550583451325_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '',
    cartUrl: 'javascript:;',
  },
  // MUJI角質調理化妝水/50mL
  4550583483302: {
    name: 'MUJI角質調理化妝水',
    number: '4550583483302',
    price: '99',
    img: {
      white_bg: '4550583483302_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '',
    cartUrl: 'javascript:;',
  },
  // 米糠發酵導入美容液/50mL
  4711441361327: {
    name: '米糠發酵導入美容液',
    number: '4711441361327',
    price: '499',
    img: {
      white_bg: '4711441361327_1260.jpg',
      usage: '',
    },
    alt: '',
    description: '使用米糠發酵液的臉部保養系列，為肌膚帶來緊緻和滋潤。含有保濕成分的玻尿酸鈉和兩種植物萃取精華。',
    cartUrl: 'javascript:;',
  },
};

export const lineupProductsData = [
  {
    id: 1,
    category: '化妝水',
    products: [
      {
        id: 1,
        item: '4550583434991',
        spec: [
          {
            title: '肌膚滲透性',
            level: '3',
          },
          {
            title: '保濕力',
            level: '4',
          },
        ],
        tabs: [
          {
            text: '300mL',
            number: '4550583434991',
            active: true,
          },
          {
            text: '50mL',
            number: '4550583483241',
            active: false,
          },
        ],
      },
      {
        id: 2,
        item: '4550583434960',
        spec: [
          {
            title: '肌膚滲透性',
            level: '4',
          },
          {
            title: '保濕力',
            level: '3',
          },
        ],
        tabs: [
          {
            text: '300mL',
            number: '4550583434960',
            active: true,
          },
          {
            text: '50mL',
            number: '4550583483234',
            active: false,
          },
        ],
      },
      {
        id: 3,
        item: '4550583434939',
        spec: [
          {
            title: '肌膚滲透性',
            level: '5',
          },
          {
            title: '保濕力',
            level: '2',
          },
        ],
        tabs: [
          {
            text: '300mL',
            number: '4550583434939',
            active: true,
          },
          {
            text: '50mL',
            number: '4550583483227',
            active: false,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    category: '乳液・乳霜',
    products: [
      {
        id: 1,
        item: '4550583435059',
        spec: [
          {
            title: '肌膚滲透性',
            level: '3',
          },
          {
            title: '保濕力',
            level: '4',
          },
        ],
        tabs: [
          {
            text: '200mL',
            number: '4550583435059',
            active: true,
          },
          {
            text: '50mL',
            number: '4550583483272',
            active: false,
          },
        ],
      },
      {
        id: 2,
        item: '4550583435035',
        spec: [
          {
            title: '肌膚滲透性',
            level: '4',
          },
          {
            title: '保濕力',
            level: '3',
          },
        ],
        tabs: [
          {
            text: '200mL',
            number: '4550583435035',
            active: true,
          },
          {
            text: '50mL',
            number: '4550583483265',
            active: false,
          },
        ],
      },
      {
        id: 3,
        item: '4550583435011',
        spec: [
          {
            title: '肌膚滲透性',
            level: '5',
          },
          {
            title: '保濕力',
            level: '2',
          },
        ],
        tabs: [
          {
            text: '200mL',
            number: '4550583435011',
            active: true,
          },
          {
            text: '50mL',
            number: '4550583483258',
            active: false,
          },
        ],
      },
      {
        id: 4,
        item: '4550583435110',
        spec: [
          {
            title: '肌膚滲透性',
            level: '2',
          },
          {
            title: '保濕力',
            level: '5',
          },
        ],
        tabs: [
          {
            text: '50g',
            number: '4550583435110',
            active: true,
          },
        ],
      },
    ],
  },
  {
    id: 3,
    category: 'ALL IN ONE',
    products: [
      {
        id: 1,
        direction: 'row',
        item: '4550583435080',
        spec: [],
        tabs: [
          {
            text: '150g',
            number: '4550583435080',
            active: true,
          },
        ],
      },
      {
        id: 2,
        direction: 'row',
        item: '4550583435073',
        spec: [],
        tabs: [
          {
            text: '30g',
            number: '4550583435073',
            active: true,
          },
        ],
      },
    ],
  },
  {
    id: 4,
    category: '調理化妝水',
    products: [
      {
        id: 1,
        item: '4550583451325',
        spec: [
          {
            title: '肌膚滲透性',
            level: '5',
          },
          {
            title: '保濕力',
            level: '2',
          },
        ],
        tabs: [
          {
            text: '300mL',
            number: '4550583451325',
            active: true,
          },
          {
            text: '50mL',
            number: '4550583483302',
            active: false,
          },
        ],
      },
    ],
  },
  {
    id: 5,
    category: '美容液',
    products: [
      {
        id: 1,
        item: '4711441361327',
        spec: [
          {
            title: '肌膚滲透性',
            level: '2',
          },
          {
            title: '保濕力',
            level: '5',
          },
        ],
        tabs: [
          {
            text: '50mL',
            number: '4711441361327',
            active: true,
          },
        ],
      },
    ],
  },
];

export const reportData = [
  {
    id: 1,
    link: 'https://www.muji.tw/tw/feature/25ss/clearcare/',
    img: 'bc_1200.jpg',
    text: '清新臉部保養系列',
  },
  {
    id: 2,
    link: 'https://www.muji.tw/tw/feature/24ss/ricebran/index.html',
    img: '640X400_ricebran_250407.jpg',
    text: '米糠發酵臉部保養系列',
  },
  {
    id: 3,
    link: 'https://www.muji.tw/tw/feature/fragrance/',
    img: '640X400_fragrance_250331.jpg',
    text: '香氣・空間香氛 伴隨著香氛的生活',
  },
  {
    id: 4,
    link: 'https://www.muji.tw/tw/feature/healthandbeauty/',
    img: 'Face-640X400-0301.jpg',
    text: '水漾潤澤',
  },
];
